// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ye2Ligtpa5UFRIe36X5R{text-align:center;width:32px;margin:0 12px}.N0YZelukd1wO2Ak3e4Wn{color:var(--content-neutral-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `ye2Ligtpa5UFRIe36X5R`,
	"optionalLabel": `N0YZelukd1wO2Ak3e4Wn`
};
export default ___CSS_LOADER_EXPORT___;
